import React from 'react';
import moment from 'moment';
import classNames from 'classnames';

/**
 * Render a simple item of a calendar event.
 * The avatar and the name of the person.
 */
class ReleaseEvent extends React.Component {
    render() {
        const { event } = this.props;
        let eventDate = moment(event.start.date);
        const today = moment();
        const diff = eventDate.diff(today, 'days') + 1;

        return (
            <div
                className={classNames(
                    'release-event',
                    `release-event--${event.type}`
                )}
            >
                <div className="release-event__date release-date">
                    <div>
                        <div className="release-date__month">
                            {eventDate.format('MMM')}
                        </div>
                        <div className="release-date__day-literal">
                            {eventDate.format('ddd')}
                        </div>
                        <div className="release-date__day">
                            {eventDate.format('DD')}
                        </div>
                    </div>
                </div>
                <div className="release-event__summary release-summary">
                    <div className="release-summary__description">
                        {event.summary}
                    </div>
                    <div className="release-summary__eta">In {diff} days</div>
                    <div className="release-summary__tag">
                        <span>{event.type}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReleaseEvent;



// WEBPACK FOOTER //
// ./src/components/Calendar/ReleaseEvent.js